import React from 'react'
import styled from 'styled-components'
import { WithAuth as Root } from '@/components/Root'
import { LayoutProps } from './props'
import UsersTable from '@/components/tables/UsersTable'
import { Layout, PageHeader } from 'antd'

const pageTitle = 'ユーザー'

export default ({ users }: LayoutProps) => (
  <Root title={pageTitle}>
    <Layout>
      <StyledPageHeader title={pageTitle} />
      <UsersTable users={users} />
    </Layout>
  </Root>
)

const StyledPageHeader = styled(PageHeader)`
  margin: 16px 0;
  background-color: #fff;
`
